import styles from './FaqsBlock.module.scss'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import { useTranslation } from 'next-i18next'
import travelFaqObject from '@/entities/travelFaq/interface'
import { TitleH2 } from '@/components/cms/Title'
import Accordion from '@/components/elements/Accordion'

interface Props {
  faqs: travelFaqObject[]
}

const FaqsBlock = ({ faqs }: Props) => {
  const { t } = useTranslation('common')
  if (!faqs.length) {
    return <></>
  }

  const accordionItems = faqs.map((faq: travelFaqObject) => ({
    title: faq.question,
    content: faq.answer,
  }))

  return (
    <>
      <Container className={styles.root}>
        <span id="faqs" className="anchor" />
        <Row>
          <Col>
            <TitleH2 title={t('travel.faqsTitle')} className={styles.title} />
            <h3 className={'mb-3'}>{t('travel.faqsSubtitle')} </h3>
            <Accordion items={accordionItems} />
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default FaqsBlock
